import { memo } from "react";

/**
 * Full-screen SVG noise texture overlay.
 * Adds organic warmth/film grain at very low opacity (0.03).
 * Hidden when reduce-motion is active (via CSS).
 */
export const NoiseOverlay = memo(function NoiseOverlay() {
  return (
    <div className="noise-overlay" aria-hidden="true">
      <svg width="100%" height="100%">
        <filter id="alchema-noise">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.65"
            numOctaves="3"
            stitchTiles="stitch"
          />
        </filter>
        <rect width="100%" height="100%" filter="url(#alchema-noise)" />
      </svg>
    </div>
  );
});
